import { Modal } from 'react-async-popup';
import '../ui/emergencyPopup.css';
import ticketService from '../../ticketService';
import TicketUpdateError from './TicketUpdateError';
import FinishCostNegotiationModal from './finishCostNegotiationModal';
import { useHistory } from 'react-router-dom';
import { mutate } from 'swr';

const useFinishCostNegotiationModal = (ticket, type) => {
  const history = useHistory();

  // open modal
  const finishCostNegotiation = async () => {
    const { show } = await Modal.new({
      content: <FinishCostNegotiationModal ticket={ticket} type={type} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  return () => {
    return finishCostNegotiation()
      .then((result) => {
        if (!result) {
          throw Error('Skip');
        }
        return result;
      })
      .then(async (dto) => {
        if (dto.changeAssignment) {
          const path = `/emergencies/${ticket.id}/quote/${ticket.quote.id}`;
          history.push(path);
          return;
        } else {
          const ticketId = ticket.id;
          const quoteId = ticket.quote.id;
          const backendResult = await ticketService.callBackend.finishCostNegotiation({
            ticketId,
            quoteId,
          });
          mutate((key) => {
            return typeof key === 'string' && key.startsWith('tickets');
          });
          return backendResult;
        }
      })
      .catch((err) => {
        if (err.message !== 'Skip') throw err;
      })
      .catch((err) => {
        if (isNaN(err.code)) throw err;

        return Modal.new({
          content: <TicketUpdateError ticket={ticket} type={type} />,
          footer: null,
        }).then(({ show }) => show());
      });
  };
};

export default useFinishCostNegotiationModal;
